import { render } from "./MediaGallery.vue?vue&type=template&id=279d4fea"
import script from "./MediaGallery.vue?vue&type=script&lang=js"
export * from "./MediaGallery.vue?vue&type=script&lang=js"

import "./MediaGallery.vue?vue&type=style&index=0&id=279d4fea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__